import React from 'react';
import { isEqual, cloneDeep } from 'lodash';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import colors from 'constants/colors';

// Use the same circles/squares for Legend symbols in Line charts
// that we use in Legends for area charts
Highcharts.seriesTypes.line.prototype.drawLegendSymbol =
  Highcharts.seriesTypes.area.prototype.drawLegendSymbol;

// Enable hiding an axis when it has no series data with `showEmpty: false`
// See: https://github.com/highcharts/highcharts/issues/705
Highcharts.Axis.prototype.hasData = function hasData() {
  return this.hasVisibleSeries;
};

// Global attributes to be applied to *all* Charts.
// Thoroughly documented here: https://api.highcharts.com/highcharts
Highcharts.setOptions({
  // Hide the link to highcharts.com
  credits: false,
  lang: {
    // Separate groups of 3 digits in large numbers with a comma
    thousandsSep: ',',
  },
  // Don’t default to “Chart title” if none is provided
  title: null,
  chart: {
    style: {
      fontFamily: 'proxima-nova, "Helvetica Neue", sans-serif',
    },
  },
  plotOptions: {
    line: {
      marker: {
        // Hide circles/squares/etc for each data point, showing only the line
        enabled: false,
      },
    },
    area: {
      marker: {
        // Hide circles/squares/etc for each data point, showing only the line
        enabled: false,
      },
      // Opacity of the area below the line
      // (by default, the same color as the line)
      fillOpacity: 0.1,
    },
    series: {
      lineWidth: 4,
    },
  },
  legend: {
    itemStyle: {
      fontSize: '12px',
      fontWeight: 'normal',
      color: colors.GRAY_DARK,
    },
  },
  xAxis: {
    lineColor: colors.GRAY_LIGHT,
    labels: {
      style: {
        color: colors.GRAY_DARK,
        fontSize: '12px',
      },
    },
    title: {
      // hide axis labels by default
      text: null,
    },
    // Don’t show vertical ticks on this axis
    tickWidth: 0,
  },
  yAxis: {
    lineColor: colors.GRAY_LIGHT,
    labels: {
      style: {
        color: colors.GRAY_DARK,
        fontSize: '12px',
      },
    },
    title: {
      // hide axis labels by default
      text: null,
    },
    // Don’t show horizontal grid lines
    gridLineWidth: 0,
    // Always start the axis at 0 so heights are proportional
    min: 0,
    // Display a 1px-wide yAxis (the default is no line)
    lineWidth: 1,
  },
});

class Chart extends React.Component {
  shouldComponentUpdate(nextProps) {
    // To prevent the chart from re-rendering when a parent component re-renders
    // we have to check if the config remains the same.
    return !isEqual(nextProps.config, this.props.config);
  }

  render() {
    // Highcharts modifies the props object we pass to it which throw off the
    // comparison we're doing in shouldComponentUpdate (╯°□°）╯︵ ┻━┻
    // Therefore, we have to deeply clone the object we're passing down to
    // prevent Highcharts from tempering with the props
    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={cloneDeep(this.props.config)}
      />
    );
  }
}

export default Chart;
